import { useDataValue } from 'Simple/Data.js'
import formatISO from 'date-fns/formatISO/index.js'
import parseISO from 'date-fns/parseISO/index.js'
import subDays from 'date-fns/subDays/index.js'
import startOfDay from 'date-fns/startOfDay/index.js'
import endOfDay from 'date-fns/endOfDay/index.js'
import { useMemo } from 'react'

/** @type {import('Simple/types.js').useDataConfiguration} */
export default function useDataConfiguration(props) {
  let locations = useDataValue({
    context: 'tab',
    path: 'selected.locations',
    viewPath: props.viewPath,
  })

  let selectedCampaigns = useDataValue({
    context: 'tab',
    path: 'selected.campaigns',
    viewPath: props.viewPath,
  })

  let selectedCampaignDateRange = useDataValue({
    context: 'tab',
    path: 'selected.range',
    viewPath: props.viewPath,
  })

  return useMemo(() => {
    // default start range
    let start_date = formatISO(startOfDay(subDays(new Date(), 30)))
    let end_date = formatISO(new Date())

    if (
      selectedCampaignDateRange.start_date &&
      selectedCampaignDateRange.end_date
    ) {
      start_date = formatISO(
        startOfDay(parseISO(selectedCampaignDateRange.start_date))
      )
      end_date = formatISO(
        endOfDay(parseISO(selectedCampaignDateRange.end_date))
      )
    }

    return {
      variables: {
        locations: `{${locations.join(',')}}`,
        campaign_ids: selectedCampaigns || [],
        start_date,
        end_date,
      },
      pause: !locations,
    }
  }, [
    locations,
    selectedCampaignDateRange.end_date,
    selectedCampaignDateRange.start_date,
    selectedCampaigns,
  ])
}
